import React from 'react';
import { Route, Link, withRouter } from "react-router-dom";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import HelpIcon from '@material-ui/icons/Help'
import LectureText from './text_view'
import LectureQuiz from './quiz_view'
import {isMobile} from 'react-device-detect'


import './lecture.css'
import { Box, CircularProgress, Snackbar } from '@material-ui/core';
import { Help } from '@material-ui/icons';

const isEqual = require("react-fast-compare")

class Lecture extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      quizvisible : false,
      quizopen : true,
      showsnackbar : false,
      ticktimer : 0,
      lecture : {text:{},test:{},external:false},
    }
  }

  componentDidMount (){
    const {params} = this.props.match ? this.props.match : false
    if (params && 'id' in params) this.setState({id : params.id})
    let s = this.props.socket
    s.on('lecture started', data => {
      this.setState({lecture : data})
      if (data.test.ticktimer) {this.setState({ticktimer:data.test.ticktimer/6})}
      if (data.editor === 'video' && data.test.ticktimer/6 < data.text.dur) {
        this.setState({quizopen:false})        
      }
    })
    s.on('ticktimer',data => {
      this.setState({ticktimer:data/6})
      if (this.state.lecture.editor === 'video' && data/6 > this.state.lecture.text.dur) {
        if (!this.state.quizopen) {
          this.setState({showsnackbar:true})
          this.setState({quizopen:true})
      }
      }
    })
    s.on('answer changed',data => {
      let quiz = this.state.lecture
      this.setState({lecture : {...quiz,test:data}})
    })
    s.emit('start lecture',{id : params.id})
  }



  toggleQuiz = () => {
    let tmp = this.state.quizvisible
    this.setState({quizvisible : !tmp})
  }


    modQuiz = (e,qindex,aindex) => {
      let quiz = this.state.lecture.test
      let s = this.props.socket
      console.log(e,qindex,aindex)
      // this.setState({lecture : {...quiz,test:newval}})
      s.emit('set answer',{id:this.state.id,qindex : qindex, aindex: aindex, value : e})
    }

    checkQuiz = () => {
      if (this.state.quizopen){
        let s = this.props.socket
        s.on('test checked', data => {
          console.log(data)
        })
        s.emit('check test',{id:this.state.id})
        s.emit('start lecture',{id : this.state.id})
    }
    }

    newQuiz = () => {
      let s = this.props.socket
      s.emit('start lecture',{id : this.state.id,newtry:true})
    }

    quizOpen = () => {

    }


  render () {
    const {lecture, id, quizvisible, quizopen, showsnackbar,ticktimer} = this.state
    return (
      <div>
        {lecture.editor !== 'video' && <Typography variant="headline" gutterBottom className='headline'>{lecture.name}</Typography>}
      <div className='container'>
        <Paper className={'textcontainer '+(isMobile && quizvisible && 'hiddentextcontainer') }>
        {'name' in lecture  &&  <LectureText id={id} text={lecture.text} editorplugin={lecture.editor || 'ory'}  socket={this.props.socket}
          external={lecture.external} userdata={this.props.userdata} currentTimestamp={lecture.test.current_timestamp || 0}
          />}
        </Paper>
      <Paper className={(!isMobile ? 'quizcontainer ' : 'quizcontainermobile ')+(quizvisible && 'quizvisible')}>
      {'name' in lecture && <LectureQuiz id={id} {...lecture.test} lectureName={lecture.name} typ={lecture.typ} lectureDuration={lecture?.duration || 2}
            userdata={this.props.userdata} lectureContent={lecture.themen} prevQ={lecture.previous_results || []} 
            ownresults={lecture.ownresults} certificate={lecture.certificate}
            checkQuiz={this.checkQuiz}  modQuiz={this.modQuiz} newQuiz={this.newQuiz}/> }
      </Paper>
      {/* <Button variant="fab" color={quizopen ? "secondary" : 'grey'} disabled={!quizopen} className='quizbutton bottom' onClick={this.toggleQuiz}> */}
        {!quizopen && 
        <Box position="relative" display="inline-flex" className='quizbutton bottom'>
        <CircularProgress variant="determinate" value={Math.round(100*ticktimer/lecture.text?.dur,) || 100} />
        <Box top={0} left={0}  bottom={0}   right={0} position="absolute"    display="flex" alignItems="center"   justifyContent="center">
          <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(100*ticktimer/lecture.text?.dur,)}%`}</Typography>
        </Box>
      </Box>
        
        
        }
        {quizopen && <Help color={quizopen ? "secondary" : 'grey'} disabled={!quizopen} className='quizbutton bottom' onClick={this.toggleQuiz}/>}
        {/* </Button> */}
      </div>
      <Snackbar open={showsnackbar} autoHideDuration={5000} onClose={e => this.setState({showsnackbar:false})} message='Test freigegeben'/>
      </div>
    )
  }


}

export default withRouter(Lecture)
